export const updateMenuWithConnection = /* GraphQL */ `
  mutation UpdateMenu(
    $input: UpdateMenuInput!
    $condition: ModelMenuConditionInput
  ) {
    updateMenu(input: $input, condition: $condition) {
      menuId
      parentMenuId
      menuNames {
        items {
          language
          name
          menuId
          schemaId
          tenant
          landscape
          createdAt
          updatedAt
        }
        nextToken
      }
      menuDescriptions {
        items {
          language
          description
          menuId
          schemaId
          tenant
          landscape
          createdAt
          updatedAt
        }
        nextToken
      }
      url
      isCategory
      product
      schemaId
      loginName
      tenant
      landscape
      tenantLandscapeLoginName
      accessedTimeStamp
      sort
      canUseFromExtra
      menuIconFont
      createdAt
      updatedAt
    }
  }
`;
